module.exports = __webpack_public_path__ + "img/10.027e6ac.png";